import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Paper,
  TextInput,
  Button,
  Title,
  Text,
  Image,
  Stack,
  Alert,
  Anchor,
} from "@mantine/core";
import { IconAlertCircle, IconCheck } from "@tabler/icons-react";
import { authService } from "../services";

const GCP_LOGO_URL =
  "https://i0.wp.com/gulfcoastpath.com/wp-content/uploads/2021/02/cropped-GCP-Logo-v1.png?fit=1628%2C1071&ssl=1";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await authService.forgotPassword({ email });
      setSuccess(true);
    } catch (err: unknown) {
      const errorMessage =
        err && typeof err === "object" && "message" in err
          ? (err as { message: string }).message
          : "An error occurred. Please try again.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Stack align="center" mb="xl">
        <Image src={GCP_LOGO_URL} alt="GCP" h={80} fit="contain" />
        <Title order={2} c="gcpBlue">
          Reset Password
        </Title>
        <Text c="dimmed" size="sm">
          Enter your email to receive a password reset link
        </Text>
      </Stack>

      <Paper withBorder shadow="md" p={30} radius="md">
        {success ? (
          <Stack>
            <Alert icon={<IconCheck size={16} />} color="green" variant="light">
              If an account with that email exists, a password reset link has
              been sent. Please check your email.
            </Alert>
            <Anchor component={Link} to="/login" size="sm" ta="center">
              Back to login
            </Anchor>
          </Stack>
        ) : (
          <form
            onSubmit={(e) => {
              handleSubmit(e).catch(() => {});
            }}
          >
            <Stack>
              {error && (
                <Alert
                  icon={<IconAlertCircle size={16} />}
                  color="red"
                  variant="light"
                >
                  {error}
                </Alert>
              )}

              <TextInput
                label="Email"
                placeholder="Enter your email address"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <Button type="submit" fullWidth loading={loading}>
                Send Reset Link
              </Button>

              <Anchor component={Link} to="/login" size="sm" ta="center">
                Back to login
              </Anchor>
            </Stack>
          </form>
        )}
      </Paper>
    </Container>
  );
}
